import { Field, ObjectType } from 'type-graphql'
import { ChatMessage } from '../chat/Chat'
import { Prop } from '@typegoose/typegoose'
import { Cache } from './Cache'
import { ChatSender } from '../chat/ChatSender'

@ObjectType()
export class CacheZendesk extends Cache {
  @Field(() => ChatSender)
  @Prop({ type: ChatSender })
  sender: ChatSender

  @Field(() => Date)
  @Prop({ type: Date })
  agentLastSeenAt: Date

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date

  @Field(() => Date)
  @Prop({ type: Date })
  senderLastSeenAt: Date

  @Field(() => String)
  @Prop({ type: String })
  subject: string

  @Field(() => String)
  @Prop({ type: String })
  lastMessageContent: string

  @Field(() => [ChatMessage])
  @Prop({ type: [ChatMessage] })
  chatMessages: [ChatMessage]
}
